import { steps } from "../config";

function getStepValue(step_str) {
    return steps.indexOf(step_str);
}

export default getStepValue;